import React, { FC } from 'react';
import { useProfile } from '@hooks/TRPC_Hooks/useProfile';
import { useGetPublicProfile } from '@hooks/TRPC_Hooks/useGetPublicProfile';
import { InputsBlockLoading } from './InputsBlockLoading';
import { InputsBlockLoaded } from './InputsBlockLoaded';
interface InputsBlockProps {
  isMobile: boolean;
}
export const InputsBlock: FC<InputsBlockProps> = ({
  isMobile
}) => {
  const {
    data: profile,
    isLoading: profileLoading
  } = useProfile();
  const {
    data: publicProfile,
    isLoading: publicProfileLoading
  } = useGetPublicProfile({
    shortId: profile?.shortid ?? ''
  }, {
    enabled: !!profile
  });
  const isLoading = profileLoading || publicProfileLoading;
  if (isLoading) return <InputsBlockLoading />;
  if (!profile) return null;
  return <InputsBlockLoaded isMobile={isMobile} profile={profile} artistProfile={publicProfile?.artistProfile} data-sentry-element="InputsBlockLoaded" data-sentry-component="InputsBlock" data-sentry-source-file="InputsBlock.tsx" />;
};